import util from '@bmp-vue/core/api/util'

const controller = 'Produto'
export default Object.assign({}, util.GetCrud(controller, null), {
  TipoGrupos: [
    { name: 'Bens Imóveis', value: 1 },
    { name: 'Bens Movel', value: 2 },
    { name: 'Bens Financeiros', value: 3 },
    { name: 'Geral', value: 4 },
  ]
})
